// extracted by mini-css-extract-plugin
export default {"item":"style_item__aTQjI","text":"style_text__kXTHl"};